import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
import Cadastro from '@/components/Cadastro'
import Cadastro2 from '@/components/Cadastro2'
import Cadastro3 from '@/components/Cadastro3'
import RecuperarSenha from '@/components/RecuperarSenha'
import { isMobile } from 'mobile-device-detect';

var loggedRoute 	= "Cadastro2";
var notLoggedRoute 	= "Cadastro";

Vue.use(Router)


const checkLogin 	= (to, from, next) => {
    var self    	= this;

    console.log("checkLogin()", to, from, next)

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	// console.log("Esta logado e a pagina nao permite", _this);
				 	if (_this.currentRoute.params.reload == 1) {
				 		console.log("Faz reload")
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            	// console.log("ELSE")
            	// if ()
            }

        } catch(err) {
            // return false;
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};


var _this = new Router({
	// mode: 'history',
  	routes: [ 
	    { 
	    	path: '/',
			// beforeEnter(to, from, next) {
		 //        // Put the full page URL including the protocol http(s) below
		 //        // window.location.replace('https://xego.negociar.tech')
		 //    },	    	 
	      	name: 'Inicio',
	      	component: Inicio,
	      	meta: {
	      		title: 		""
	      	},	    	
	    },
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/cadastro/2/',
	      	name: 'Cadastro2',
	      	meta: {
	      		title: 		"Cadastro",
		      	// level: 		["prestador"],
	      		auth: 		true,
	      	},
	      	component: Cadastro2,
	      	beforeEnter: checkLogin,
	    },		
	    {
	      	path: '/cadastro/realizado/',
	      	name: 'Cadastro3',
	      	meta: {
	      		title: 		"Cadastro realizado",
		      	// level: 		["prestador"],
	      		auth: 		true,
	      	},
	      	component: Cadastro3,
	      	beforeEnter: checkLogin,
	    },			      
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		auth: 		false,
	      	},
	      	component: RecuperarSenha
	    },	            	    		    	           
	    { path: '*', redirect: '/' }
  	]
})


const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".dashboard-content-inner")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".dashboard-content-inner")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js